<template>
  <div class="box2">
    <div class="block">
      <div class="title">
        <img
          src="../../../assets/coursePage/architect/box2/left-title.png"
          alt
        />
        <p>6个月成为傲娇的Java架构师</p>
        <img
          src="../../../assets/coursePage/architect/box2/right-title.png"
          alt
        />
      </div>

      <div class="item" v-for="(item, index) in list" :key="index">
        <div class="tit">{{ item.tit }}</div>
        <p>
          <span></span>
          {{ item.p }}
        </p>
      </div>
    </div>

    <!-- <div class="salary">
      <p>《狂野架构师》</p>
      <p><span>最高薪资涨幅 81.82%</span><span>平均涨幅 32.35%</span></p>
      <p>一线最高薪资 <span>37500元/月 </span></p>
      <p>非一线最高薪资 <span>26000元/月</span></p>
      <p>平均薪资 <span>22027元/月 </span></p>
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        {
          tit: "分布式系统构建能力",
          p: "解决企业核心类库建设问题",
        },
        {
          tit: "Web系统调优能力",
          p: "解决企业三高问题",
        },
        {
          tit: "项目架构选型能力",
          p: "解决中间件选型问题",
        },
        {
          tit: "云服务构建能力",
          p: "解决系统弹性扩缩容问题",
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.box2 {
  // padding-top: 80px;
  width: 100%;
  background: #fff;
  .block {
    position: relative;
    margin: 0 auto;
    margin-top: -64px;
    padding-top: 68px;

    width: 729px;
    height: 703px;

    background: url("../../../assets/coursePage/architect/box2/sever.png")
      no-repeat;
    background-size: cover;
    box-sizing: border-box;

    .title {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 37px;
      margin-bottom: 52px;
      img {
        width: 22px;
        height: 23px;
      }
      p {
        margin: 0px 15px;
        font-size: 36px;
        font-weight: bold;
        font-family: PingFangSC-Medium;
        line-height: 36px;
        letter-spacing: 0px;
        color: #000;
        background: linear-gradient(270deg, #44c1fb, #288fef);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }

    .item {
      margin-left: 100px;
      padding-bottom: 24px;
      width: 350px;
      // height: 160px;
      box-sizing: border-box;
      border-bottom: 1px solid #daeaff;

      &:last-child {
        border-bottom: none;
      }

      .tit {
        position: relative;

        font-family: PingFangSC-Medium;
        font-size: 28px;
        font-weight: bold;
        // line-height: 36px;
        letter-spacing: 0px;
        color: #333333;
        margin-top: 28px;
      }

      p {
        display: flex;
        align-items: center;

        font-family: PingFang SC;
        font-size: 24px;
        font-weight: normal;
        font-stretch: normal;
        // line-height: 36px;
        letter-spacing: 0px;
        color: #4e5969;
      }
    }
    .item:nth-child(2) {
      .tit {
        margin-top: 0;
      }
    }
  }

  .salary {
    margin: 24px auto 0;
    width: 686px;
    padding-bottom: 16px;
    background: linear-gradient(180deg, #fff9f8 0%, #fffdfc 100%);
    border-radius: 20px;
    padding-top: 24px;
display: none;
    p:nth-child(1) {
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #1d2129;
      line-height: 48px;
      text-align: center;
    }
    p:nth-child(2) {
      width: 622px;
      height: 64px;
      background: #ff5622;
      border-radius: 8px;
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 64px;
      text-align: center;
      margin: 32px auto 16px;
      span:first-child {
        margin-right: 48px;
      }
    }
    p:nth-child(3),
    p:nth-child(4),
    p:nth-child(5) {
      text-align: center;
      margin: 0 auto;
      width: 622px;
      height: 64px;
      background: #ffffff;
      border-radius: 8px;
      border: 2px solid #ffe5dd;
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #1d2129;
      line-height: 64px;
      margin-bottom: 16px;
      span {
        color: rgba(255, 86, 34, 1);
      }
    }
  }
}
</style>
